import { use } from "react";
import { DepositWizardContext } from "../DepositWizardContext";

export const useDepositWizard = () => {
  const ctx = use(DepositWizardContext);

  if (!ctx) {
    throw new Error("useDepositWizard must be used within DepositWizard");
  }

  return ctx;
};
